import React, { useCallback, useEffect, useState } from "react";
import { handleError } from "../../utils/handleError";
import { supabase } from "../../supabaseClient";
import { SavedContent } from "../../types/api/SavedContent";

export function useSavedDescriptions() {
  const [savedDescriptions, setSavedDescriptions] = useState<SavedContent[]>(
    []
  );
  const [loading, setLoading] = useState(true);

  const getSavedDescriptions = useCallback(async () => {
    setLoading(true);
    try {
      let { data, error, status } = await supabase
        .from("saved_content")
        .select("*");

      if (error && status !== 406) {
        throw error;
      }

      if (data) {
        console.log("SAVED DESCRIPTION HOOK DATA", data);
        setSavedDescriptions(data as SavedContent[]);
      }
    } catch (error) {
      handleError(error as Error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getSavedDescriptions();
  }, [getSavedDescriptions]);

  return { savedDescriptions, loading };
}
